import axios from 'axios'

//通用合理值查询详情
export function getFairValue (data) {
  return axios.get(`/manage/universalFairValue/selectByName`, { params: data })
}

